import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalculoPensaoService {

  private apiUrl = `${environment.API_URL}/calculo-beneficio`;

  constructor(
    private httpClient: HttpClient
  ) { }

  public salvarCalculoBeneficio(calculoBeneficio: any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}`, calculoBeneficio);
  }
}
